import EventsHandler from "../utils/eventshandler";
import {Events} from "./CartEvents";
import {Helpers} from "../../../common/js/Helpers";

/**
 * takes care about the external cart connector buttons on the images:
 * - update the click events
 */

export class CartConnectorButtonHandler {
    eventHandler:EventsHandler = new EventsHandler();

    /** True while a cart request has not come back yet. */
    private isBusy: boolean = false;

    /** Target of a click which arrived while a request was still running. */
    private pendingHref: string = null;

    constructor(cartProcessor?: any) {
        this.initializeCartConnectorButtons();
        document.addEventListener(Events.rebindAdd2CartButtons, () => {this.initializeCartConnectorButtons()})

        // Nicht weiternavigieren, solange der Warenkorb noch geschrieben wird.
        // Ein Seitenwechsel bricht laufende Anfragen ab, und dann fehlt genau
        // der Artikel, den der Besucher gerade hinzugefügt hat.
        document.addEventListener(Events.busy, (e: CustomEvent) => {
            this.isBusy = e.detail?.busy === true;
            if (!this.isBusy && this.pendingHref) {
                let href = this.pendingHref;
                this.pendingHref = null;
                window.location.href = href;
            }
        });
    }

    initializeCartConnectorButtons() {
        let cartConnectorButtons = document.getElementsByClassName('eventgallery-cart-connector');
        Array.prototype.forEach.call(cartConnectorButtons, (btn: HTMLBaseElement)=> {
            this.eventHandler.off('click', btn);
            this.eventHandler.on('click', btn, (e:Event) => {this.openLink(e)});
        });
    }

    openLink(e: Event) {
        e.preventDefault();
        e.stopPropagation();
        let link: HTMLElement = e.target as HTMLElement;

        if (!link.getAttribute('data-href')) {
            link = Helpers.getParent(link, 'SPAN');
        }

        let href = link.getAttribute('data-href');

        // Läuft noch eine Anfrage, wird der Klick gemerkt und ausgeführt,
        // sobald sie durch ist.
        if (this.isBusy) {
            this.pendingHref = href;
            return;
        }

        window.location.href = href;
    };
}
